import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { ErrorResponse } from "../../../requests/@types";
import { MediaAddressResponse } from "../@types";
import api from "../api";

const SAMPLE_REPORT_GETMEDIAADDRESS_KEY = "sampleReportGetMediaAddress";

const getQueryFn = (hash: string) => api.getMediaaddress(hash);

const getQueryKey = (hash?: string) => [
  SAMPLE_REPORT_GETMEDIAADDRESS_KEY,
  hash
];

const useGetMediaAddress = (hash: string) => {
  const { isLoading, isFetched, data } = useQuery<
    AxiosResponse<MediaAddressResponse>,
    ErrorResponse,
    MediaAddressResponse
  >({
    queryFn: () => getQueryFn(hash),
    queryKey: getQueryKey(hash),
    select: ({ data: responseData }) => responseData,
    enabled: Boolean(hash)
  });

  return { isLoading, isFetched, data };
};

export default useGetMediaAddress;
